import { useRef } from 'react'
import { useSetState } from 'ahooks'
import { message, Switch } from 'antd'
import {
  SActionBtn,
  SDrawerOrModal,
  SFuncModalFormRef,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'

import { config } from './config.tsx'
import AddOrEditConfigure from './addOrEdit'
import {
  argDelete,
  argUpdateState,
  getArgPage,
  getProductEnums,
  getSpaceArgPage,
  SpaceSpecificationArgDelete,
  spaceSpecificationArgUpdateState,
} from '@/services/product.ts'
import { apiData2Table } from '@/utils/data.ts'

const CustomParameter = props => {
  const listRef = useRef()
  const editRef = useRef<SFuncModalFormRef>({ onFinish: undefined })

  const [state, setState] = useSetState({
    exportLoading: false,
    visible: false,
    record: {},
    options: {},
    btnLoading: false,
  })

  const fetchList = ({ current, pageSize, query }) => {
    return new Promise((resolve, reject) => {
      getSpaceArgPage({
        params: { pageId: current, pageSize },
        data: {
          ...query,
        //   queryValues: true,
        },
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const getStatusOptions = async () => {
    const argTypeEnum = await getProductEnums('com.shj.saas.plus.product.enums.ArgManageTypeEnum')
    const statueEnum = await getProductEnums('com.shj.saas.plus.product.enums.StatueEnum')
    setState({ options: { argTypeEnum } })
    return Promise.resolve({ argTypeEnum, statueEnum })
  }

  const onChangeStatus = (enabled: boolean, id: string) => {
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关，将${enabled ? '启用' : '禁用'}参数，是否继续？`,
      okText: '继续',
      content: null,
      onOk: () => {
        return spaceSpecificationArgUpdateState({ data: { enabled, idList: [id] } }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onAddOrEdit = (record = {}) => {
    setState({ visible: true, record: { ...record } })
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
        return SpaceSpecificationArgDelete(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onSubmit = () => {
    editRef.current.onFinish?.()
  }

  const onCancel = () => {
    setState({ visible: false, btnLoading: false })
  }

  const setLoading = (btnLoading: boolean) => {
    console.log(btnLoading)
    setState({ btnLoading })
  }

  const extensions = {
    request: { fetchList, getStatusOptions },
    events: { onAdd: () => onAddOrEdit() },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return (
          <Switch
            disabled={record.systemArgFlag}
            checkedChildren="启用"
            unCheckedChildren="禁用"
            checked={v}
            onClick={checked => onChangeStatus(checked, record.id)}
          />
        )
      },
      jsonRender(v, record) {
        return v?.map(item => item.argValue)?.join(', ')
      },
      actionRender(_: null, record: Record<string, any>) {
        if (!record.systemArgFlag) {
          return (
            <STableActions>
              <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
              <SActionBtn danger onClick={() => onDel(record.id)}>
                删除
              </SActionBtn>
            </STableActions>
          )
        }
      },
    },
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode={'group'} config={config} {...extensions} />
      <SDrawerOrModal
        mode={'modal'}
        width={500}
        onCancel={onCancel}
        onOk={onSubmit}
        open={state.visible}
        loading={state.btnLoading}
        title={(state.record.id ? '编辑' : '新增') + '配置'}
      >
        <AddOrEditConfigure
          editRef={editRef.current}
          {...state.options}
          onCancel={onCancel}
          setLoading={setLoading}
          fn={listRef.current?.reload}
          record={state.record}
        />
      </SDrawerOrModal>
    </div>
  )
}

export default CustomParameter
